import React from "react";
import { Plus, Calendar, GraduationCap, Code2, CreditCard } from "lucide-react";

const QuickActionsSection = ({
  onAddChild,
  onBookDemo,
  onMyEnrollments,
  onOpenCodeStudio,
  onPayments,
}) => {
  const actions = [
    {
      id: "add-child",
      title: "Add Child",
      description: "Add a new child to your account",
      icon: <Plus className="w-5 h-5 stroke-[2.5]" />,
      iconBg: "bg-[#edf0ff] text-[#5468ff]",
      onClick: onAddChild,
    },
    {
      id: "book-demo",
      title: "Book Free Demo",
      description: "Try a course before enrolling",
      icon: <Calendar className="w-5 h-5" />,
      iconBg: "bg-[#e6fbf2] text-[#0fb66f]",
      onClick: onBookDemo,
    },
    {
      id: "my-enrollments",
      title: "My Enrollments",
      description: "View all active courses",
      icon: <GraduationCap className="w-5 h-5" />,
      iconBg: "bg-[#e8f1fd] text-[#2f80ed]",
      onClick: onMyEnrollments,
    },
    {
      id: "open-code-studio",
      title: "Open Code Studio",
      description: "Launch interactive code sandbox",
      icon: <Code2 className="w-5 h-5" />,
      iconBg: "bg-[#fbf0ff] text-[#9b51e0]",
      onClick: onOpenCodeStudio,
    },
    {
      id: "payments",
      title: "Payments",
      description: "Manage billing & invoices",
      icon: <CreditCard className="w-5 h-5" />,
      iconBg: "bg-[#f0f4f8] text-[#5a6e85]",
      onClick: onPayments,
    },
  ];

  return (
    <div className="space-y-4 text-left">
      {/* Section Header (Outside Container Card) */}
      <h3 className="text-xl sm:text-2xl font-black text-slate-900 tracking-tight">
        Quick Actions
      </h3>

      {/* Container Card containing the action cards */}
      <div className="bg-white border border-slate-200/90 rounded-3xl p-5 sm:p-6 shadow-xs">
        {/* Responsive Grid:
            - 5 in row on very large devices (xl)
            - 4 in row on large devices / laptops (lg)
            - 3 in row on medium devices / tablets (md)
            - 2 in row on small devices (sm)
            - 1 in row on extra small mobile (default)
        */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3.5 sm:gap-4">
        {actions.map((action) => (
          <button
            key={action.id}
            type="button"
            onClick={action.onClick || undefined}
            title={!action.onClick ? "Coming Soon" : undefined}
            className="bg-white border border-slate-200/90 hover:border-indigo-400/80 rounded-2xl p-4 sm:p-4.5 transition-all duration-200 shadow-3xs hover:shadow-xs hover:-translate-y-0.5 flex flex-col justify-between space-y-3 cursor-pointer text-left group"
          >
            {/* Action Icon */}
            <div
              className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform group-hover:scale-105 ${action.iconBg}`}
            >
              {action.icon}
            </div>

            {/* Action Text */}
            <div className="space-y-0.5">
              <h4 className="text-sm sm:text-base font-extrabold text-slate-900 leading-tight group-hover:text-indigo-600 transition-colors">
                {action.title}
              </h4>
              <p className="text-xs text-slate-400 font-medium leading-normal">
                {action.description}
              </p>
            </div>
          </button>
        ))}
        </div>
      </div>
    </div>
  );
};

export default QuickActionsSection;
